module.exports = __webpack_public_path__ + "img/buy_now_amz.54bfe934.png";